const SkillsData = [
  { name: "Linux", image: require("../assets/Images/linux.png") },
  { name: "Git", image: require("../assets/Images/git.png") },
  { name: "GitHub", image: require("../assets/Images/github.png") },

  { name: "Docker", image: require("../assets/Images/docker.png") },
  { name: "Kubernetes", image: require("../assets/Images/kubernetes.png") },
  { name: "Helm", image: require("../assets/Images/helm.png") },

  { name: "Jenkins", image: require("../assets/Images/jenkins.png") },
  { name: "GitHub Actions", image: require("../assets/Images/github-actions.png") },
  { name: "GitLab CI", image: require("../assets/Images/gitlab-ci.png") },

  { name: "Terraform", image: require("../assets/Images/terraform.png") },
  { name: "ArgoCD", image: require("../assets/Images/argocd.png") },

  { name: "AWS", image: require("../assets/Images/aws.png") },
  { name: "GCP", image: require("../assets/Images/gcp.png") },
  { name: "Azure", image: require("../assets/Images/azure.png") },

  { name: "Prometheus", image: require("../assets/Images/prometheus.png") },
  { name: "Grafana", image: require("../assets/Images/grafana.png") },

  { name: "Trivy", image: require("../assets/Images/trivy.png") },
  { name: "OWASP", image: require("../assets/Images/owasp.png") },
  { name: "SonarQube", image: require("../assets/Images/sonar-qube.png") }
];

export default SkillsData;



